import type { LlmParam, LlmParamErrors } from './types'
import { REQUIRED_MSG } from './constants'
import {
  InputParamsContainer,
  LlmParamRow,
  LlmParamField,
  LlmAddParameterButton,
  RemoveParamButton,
} from './styles'
import WizrText from '../../WizrText'
import WizrInput from '../../WizrInput'
import CloseIconOutlined from '../../../assets/icons/CloseIconOutlined'

interface LlmParametersListProps {
  llmParams: LlmParam[]
  llmParamErrors: LlmParamErrors
  addParamRow: () => void
  removeParamRow: (id: string) => void
  updateParamRow: (id: string, field: 'name' | 'value', value: string) => void
}

const LlmParametersList = ({
  llmParams,
  llmParamErrors,
  addParamRow,
  removeParamRow,
  updateParamRow,
}: LlmParametersListProps): JSX.Element => (
  <InputParamsContainer>
    <WizrText
      type='sub2'
      style={{ fontWeight: 600, color: '#1d1f22', margin: 0, textAlign: 'left' }}
    >
      LLM Parameters
    </WizrText>

    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%' }}>
      {llmParams.map((p) => (
        <div key={p.id} data-validation-field={`llm-${p.id}`} style={{ width: '100%' }}>
          <LlmParamRow flexDirection='row' justifyContent='flex-start' background='transparent'>
            <LlmParamField>
              <WizrInput
                placeholder='Parameter Name'
                value={p.name}
                onChange={(v: string) => updateParamRow(p.id, 'name', v)}
                style={{ width: '100%' }}
                background='#F2F4F9'
                showError={!!llmParamErrors[p.id]?.name}
                errorMessage={llmParamErrors[p.id]?.name ? REQUIRED_MSG : undefined}
              />
            </LlmParamField>
            <LlmParamField>
              <WizrInput
                placeholder='Value'
                value={p.value}
                onChange={(v: string) => updateParamRow(p.id, 'value', v)}
                style={{ width: '100%' }}
                background='#F2F4F9'
                showError={!!llmParamErrors[p.id]?.value}
                errorMessage={llmParamErrors[p.id]?.value ? REQUIRED_MSG : undefined}
              />
            </LlmParamField>
            <RemoveParamButton
              type='text'
              icon={<CloseIconOutlined />}
              onClick={() => removeParamRow(p.id)}
              aria-label='Remove parameter'
            />
          </LlmParamRow>
        </div>
      ))}
    </div>

    <LlmAddParameterButton type='default' onClick={addParamRow}>
      Add Parameter
    </LlmAddParameterButton>
  </InputParamsContainer>
)

export default LlmParametersList
